export default __webpack_public_path__ + "static/media/avatar-blur-01.3ab2a377.png";